import { api } from "./axios";

// User related endpoints
export const pitchesApi = {
  create: (data: any) => api.post("/pitches/create-pitch", data),
  saveDraft: (data: any) => api.post("/pitches/save-pitch-draft", data),
  updateDraft: (pitchId: number, data: any) =>
    api.put(`/pitches/update-pitch-draft/${pitchId}`, data),
  getAll: ({
    page = 1,
    limit = 10,
    past = false,
    search = "",
    searchType = "artist",
    status = [] as string[],
  } = {}) =>
    api.get(`/pitches/get-all-pitches`, {
      params: {
        page,
        limit,
        past,
        search,
        searchType,
        status: status.length > 0 ? status.join(",") : undefined,
      },
    }),
  getOne: (id: number) => api.get(`/pitches/get-pitch/${id}`),
  update: (id: number, data: any) =>
    api.put(`/pitches/update-pitch/${id}`, data),
  updateDelivery: (
    pitchId: number,
    data: { status?: string; deliveredDSPs: string[] }
  ) => api.put(`/pitches/update-pitch-delivery/${pitchId}`, data),

  getDelivery: (pitchId: number) =>
    api.get(`/pitches/get-pitch-delivery/${pitchId}`),

  checkArtistUpdates: (pitchId: number, artistName: string) =>
    api.get(`/pitches/check-artist-updates/${pitchId}`, {
      params: { artistName },
    }),

  syncArtistData: (pitchId: number, artistName: string) =>
    api.put(`/pitches/sync-artist-data/${pitchId}`, { artistName }),

  importCSV: (csvData: any[]) => {
    return api.post("/pitches/import-csv", { csvData });
  },
  deletePitch: (pitchIds: number[]) =>
    api.delete("/pitches/bulk-delete", { data: { pitchIds } }),
  checkDuplicateArtist: (artistName: string[]) =>
    api.post("/artists/check-duplicates-artist", { artistName }),
};


